"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-plugins/lib/constants");

var _draftExtend = require("draft-extend");

var _react = _interopRequireDefault(require("react"));

// definetly should make a plug-in that just takes in a className and entity type
// since this is just c-c,c-v of the HighlightPlugin
var ChangePluginDecorator = {
  strategy: _draftExtend.pluginUtils.entityStrategy(_constants.ENTITY_TYPES.change),
  component: function component(_ref) {
    var children = _ref.children;
    return _react.default.createElement("span", {
      className: "change-plugin-just-updated"
    }, children);
  }
};

var _default = function _default() {
  return (0, _draftExtend.createPlugin)({
    displayName: 'ChangePlugin',
    decorators: ChangePluginDecorator
  });
};

exports.default = _default;
module.exports = exports.default;